<div class="container">
    <div class="breadcrumbs hidden-xs hidden-sm">{{'products.heading.breadcrumbs' | translate}}</div>
    <h3>{{'products.heading.title' | translate}}</h3>
    <div class=" col-md-12 inventory-prods" *ngIf='products && products.length  > 0'>
        <div kendo-list-view id="listView" class="row equal">
            <div class="col-md-4 col-sm-4 col-xs-12" *ngFor='let product of products'>
                <div class="panel-primary inventory-item">


                    <!---BACKUP
                            <div class="panel-body inventory-item-body" >
                                <div class="row">
                                    <div class="col-xs-5 ">
                                         <a [routerLink]="['/detail/from', repId]" [queryParams]="{prodId: product.ProductID}"> <img  style="max-height: 152px; max-width: 120px;" src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{product.SmallImageURL}}" /> </a>
                                    </div>
                                    <div class="col-xs-7">
                                        <h5>
                                            <a [routerLink]="['/detail/from', repId]" [queryParams]="{prodId: product.ProductID}"> {{ product.DisplayName }} </a> 
                                        </h5>
                                        ///<div class="text-muted text-overflow" style="text-align: right;">{{ product.ProductID }}</div>
                                        <div align="right"><button (click)="addProduct(product.ProductID, product.DisplayName, product.Price, product.SmallImageURL)" class='btn btn-primary btn-xs'> Add <i class="fa fa-cart-plus"></i></button></div>
                                        <br/>
                                        <div style="font-weight: bold; text-align:right;">{{product.Price | currency:'USD':true:'1.2-2'}}</div>
                                        
                                    </div>                                    
                                </div>
                            </div>
                            -->


                    <div class="panel-body inventory-item-body">
                        <a class="inventory-item-full-link" [routerLink]="['/detail/from', repId]"
                            [queryParams]='{ prodId: product.ProductID}'>
                            <div class="row1">
                                <div class="col-xs-12 item-thumb">
                                    <div
                                        [ngStyle]="{'background-image': 'url(https://extranet.securefreedom.com/lbri/Shopping/Images/' + product.SmallImageURL + ')'}">
                                        <!--<img src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{product.SmallImageURL}}" />-->
                                    </div>
                                </div>
                            </div>
                            <div class="row2">
                                <div class="col-xs-12 item-display-name">
                                    {{ product.DisplayName }}
                                </div>
                            </div>
                            <div class="row3">
                                <div class="col-xs-12 item-sku">
                                    {{ product.ProductID }}
                                </div>
                            </div>
                            <div class="row4">
                                <div class="col-xs-12 item-price">
                                    {{product.Price | currency:'USD':true:'1.2-2'}}
                                </div>
                            </div>
                        </a>
                        <div class="row5">
                            <div class="col-xs-12 ">
                                <div align="center"><button
                                        (click)="addProduct2(product.ProductID, product.DisplayName, product.Price, product.SmallImageURL)"
                                        class='btn btn-primary btn-xs quickadd btn-black'><span class="fa fa-plus"
                                            aria-hidden="true"></span><!--<strong> + </strong>-->&nbsp; {{'products.buttons.add1' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <simple-notifications [options]="options"></simple-notifications> -->

            <!--{{count}}-->
        </div>
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise"
            [fullScreen]="true">
            <p style="color: white"> {{'products.spinner.signingyouin' | translate}} </p>
        </ngx-spinner>
        <!--<div class='table-responsive'>
                <table class='table' *ngIf='products && products.length'>
                    <thead>
                        <tr>
                            <th>Product ID</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Image</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor='let product of products'>   
                        <td>                             
                             {{product.ProductID}}                             
                        </td>                       
                        <td>                             
                             {{product.DisplayName}}
                        </td>                        
                        <td>{{ product.Price | currency:'USD':true:'1.2-2' }}</td>
                        <td>                             
                            <img src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{product.SmallImageURL}}" />
                        </td> 
                        <td><button (click)="addProduct()" class='btn btn-primary'> Add to Cart</button></td>
                    </tr>            
                    </tbody>
                </table>
            </div>-->
        <!--<div class='table-responsive'>
                <table class='table' *ngIf='products && products.length'>
                    <thead>
                        <tr>
                            <th>Product ID</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Image</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor='let product of products'>   
                        <td>                             
                             {{product.ProductID}}                             
                        </td>                       
                        <td>                             
                             {{product.DisplayName}}
                        </td>                        
                        <td>{{ product.Price | currency:'USD':true:'1.2-2' }}</td>
                        <td>                             
                            <img src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{product.SmallImageURL}}" />
                        </td> 
                        <td><button (click)="addProduct()" class='btn btn-primary'> Add to Cart</button></td>
                    </tr>            
                    </tbody>
                </table>
            </div>-->

        <br />
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise"
            [fullScreen]="true">
            <p style="color: white"> {{'products.spinner.signingyouin' | translate}}</p>
        </ngx-spinner>